// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HomeSlider-navigationIcon-YLye3 {
	display: block;
	fill: #484848;
	height: 36px;
	width: 36px;
	font-size: 36px;
	margin: 0 auto;
}

.HomeSlider-HRCar-TQDpn {
	width: 100%;
	padding-top: 56.80%;
	background-size: cover;
	background-position: 50% 73%;
	position: relative;
	border-radius: 6px;
	background-color: #ccc;
}

.HomeSlider-PerDay-IuURU {
	color: var(--common-text-color);
	font-size: 20px;
	font-weight: 600;
}

.HomeSlider-perNightCss-BwPPe {
	font-size: 14px;
	font-weight: 400;
}

.HomeSlider-HRDetails-MLh7_ {
	margin: 0px 0px 6px 0px;
}

.HomeSlider-HRRight-WsgYh {
	background: var(--common-background-color) !important;
	border-radius: 6px;
	margin-top: 15px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	padding: 12px;
}

.HomeSlider-btn-D4496 {
	width: 100%;
	color: var(--white-text) !important;
	display: block;
	text-decoration: none;
	text-align: center;
	font-size: 18px;
	font-weight: 500;
}

.HomeSlider-margintop5-XpEjt {
	margin-top: 0px !important;
	margin-bottom: 3px !important;
}

.HomeSlider-sliderbackground-GmCm0 {
	background: var(--primary-white-bg);
	padding: 10px 0px 0px;
	outline: none !important;
}

.HomeSlider-hiddentextSlider-oV6Cv {
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	word-wrap: break-word;
	margin: 0;
}

.HomeSlider-positionRelative-Qvr79 {
	position: relative;
	border-radius: 4px;
	padding: 5px 0px;
}

.HomeSlider-boxShadow-v7K0V {
	background: var(--primary-white-bg);
	border: 1px solid var(--search-input-border);
	border-radius: 12px;
	padding: 15px;
}

.HomeSlider-titleCss-iNvNi {
	font-size: 18px;
	color: var(--common-text-color);
	margin: 5px 0 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	font-weight: 400;
}

.HomeSlider-reviewCss-B1tOg {
	border-right: 1px solid var(--primary-border);
	padding: 0 12px 0 0;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	color: var(--white-text);
	font-weight: 500;
	-webkit-box-align: baseline;
	    -ms-flex-align: baseline;
	        align-items: baseline;
}

.HomeSlider-arrowIconCss-ssom4 {
	padding-left: 6px;
}

.HomeSlider-trip-Mlv27 {
	font-size: 14px;
	color: var(--common-text-color);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.HomeSlider-carType-zAR9b {
	padding-right: 3px;
}

.HomeSlider-dotCss-tUM7c {
	width: 4px;
	height: 4px;
	background: var(--common-background-color);
	border-radius: 50%;
	margin: 0 4px;
	-ms-flex-negative: 0;
	    flex-shrink: 0;
}

.HomeSlider-reviewCssImg-_Vw54 {
	margin-right: 4px;
}

.HomeSlider-textFlow-BJQAL {
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.HomeSlider-instantIcon-X5_4z {
	color: var(--instantBookIcon-Color);
	height: 16px;
	width: 16px;
}

.HomeSlider-homeSlickSliderContainer-I57ss {
	position: relative;
}

.HomeSlider-carTypeText-D0TYn {
	max-width: 40%;
}

.HomeSlider-listingCardCarTypeAndTransmissionLabelFlexContainer-g5rFA {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	font-size: 14px;
	color: var(--primary-foreground);
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
}

.HomeSlider-listingCardCarTypeAndTransmissionLabelFlexContainer-g5rFA>div {
	max-width: 50%;
}

.HomeSlider-transmissionLabelText-MOvSk {
	position: relative;
	-webkit-padding-start: 15px;
	        padding-inline-start: 15px;
}

.HomeSlider-transmissionLabelText-MOvSk::before {
	content: '';
	position: absolute;
	width: 4px;
	height: 4px;
	background: var(--common-background-color);
	border-radius: 50%;
	left: 5px;
	top: 8px;
}

.HomeSlider-carTypeIcon-flOTm{
	position: relative;
	top: -2px;
}

@media(max-width:767px) {
	.HomeSlider-positionRelative-Qvr79 {
		padding: 5px 0;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Home/HomeSlider/HomeSlider.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,aAAa;CACb,YAAY;CACZ,WAAW;CACX,eAAe;CACf,cAAc;AACf;;AAEA;CACC,WAAW;CACX,mBAAmB;CACnB,sBAAsB;CACtB,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,+BAA+B;CAC/B,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,qDAAqD;CACrD,kBAAkB;CAClB,gBAAgB;CAChB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,WAAW;CACX,mCAAmC;CACnC,cAAc;CACd,qBAAqB;CACrB,kBAAkB;CAClB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;CAC1B,6BAA6B;AAC9B;;AAEA;CACC,mCAAmC;CACnC,qBAAqB;CACrB,wBAAwB;AACzB;;AAEA;CACC,mBAAmB;CACnB,uBAAuB;CACvB,gBAAgB;CAChB,qBAAqB;CACrB,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,mCAAmC;CACnC,4CAA4C;CAC5C,mBAAmB;CACnB,aAAa;AACd;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,eAAe;CACf,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,6CAA6C;CAC7C,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAwB;CACxB,gBAAgB;CAChB,2BAAqB;KAArB,wBAAqB;SAArB,qBAAqB;AACtB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,eAAe;CACf,+BAA+B;CAC/B,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,UAAU;CACV,WAAW;CACX,0CAA0C;CAC1C,kBAAkB;CAClB,aAAa;CACb,oBAAc;KAAd,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,mCAAmC;CACnC,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,eAAe;CACf,gCAAgC;CAChC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;AACpB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,2BAA0B;SAA1B,0BAA0B;AAC3B;;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,0CAA0C;CAC1C,kBAAkB;CAClB,SAAS;CACT,QAAQ;AACT;;AACA;CACC,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC;EACC,cAAc;CACf;AACD","sourcesContent":[".navigationIcon {\n\tdisplay: block;\n\tfill: #484848;\n\theight: 36px;\n\twidth: 36px;\n\tfont-size: 36px;\n\tmargin: 0 auto;\n}\n\n.HRCar {\n\twidth: 100%;\n\tpadding-top: 56.80%;\n\tbackground-size: cover;\n\tbackground-position: 50% 73%;\n\tposition: relative;\n\tborder-radius: 6px;\n\tbackground-color: #ccc;\n}\n\n.PerDay {\n\tcolor: var(--common-text-color);\n\tfont-size: 20px;\n\tfont-weight: 600;\n}\n\n.perNightCss {\n\tfont-size: 14px;\n\tfont-weight: 400;\n}\n\n.HRDetails {\n\tmargin: 0px 0px 6px 0px;\n}\n\n.HRRight {\n\tbackground: var(--common-background-color) !important;\n\tborder-radius: 6px;\n\tmargin-top: 15px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 12px;\n}\n\n.btn {\n\twidth: 100%;\n\tcolor: var(--white-text) !important;\n\tdisplay: block;\n\ttext-decoration: none;\n\ttext-align: center;\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.margintop5 {\n\tmargin-top: 0px !important;\n\tmargin-bottom: 3px !important;\n}\n\n.sliderbackground {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px 0px 0px;\n\toutline: none !important;\n}\n\n.hiddentextSlider {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tword-wrap: break-word;\n\tmargin: 0;\n}\n\n.positionRelative {\n\tposition: relative;\n\tborder-radius: 4px;\n\tpadding: 5px 0px;\n}\n\n.boxShadow {\n\tbackground: var(--primary-white-bg);\n\tborder: 1px solid var(--search-input-border);\n\tborder-radius: 12px;\n\tpadding: 15px;\n}\n\n.titleCss {\n\tfont-size: 18px;\n\tcolor: var(--common-text-color);\n\tmargin: 5px 0 0;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\tfont-weight: 400;\n}\n\n.reviewCss {\n\tborder-right: 1px solid var(--primary-border);\n\tpadding: 0 12px 0 0;\n\tdisplay: flex;\n\tcolor: var(--white-text);\n\tfont-weight: 500;\n\talign-items: baseline;\n}\n\n.arrowIconCss {\n\tpadding-left: 6px;\n}\n\n.trip {\n\tfont-size: 14px;\n\tcolor: var(--common-text-color);\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.carType {\n\tpadding-right: 3px;\n}\n\n.dotCss {\n\twidth: 4px;\n\theight: 4px;\n\tbackground: var(--common-background-color);\n\tborder-radius: 50%;\n\tmargin: 0 4px;\n\tflex-shrink: 0;\n}\n\n.reviewCssImg {\n\tmargin-right: 4px;\n}\n\n.textFlow {\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.instantIcon {\n\tcolor: var(--instantBookIcon-Color);\n\theight: 16px;\n\twidth: 16px;\n}\n\n.homeSlickSliderContainer {\n\tposition: relative;\n}\n\n.carTypeText {\n\tmax-width: 40%;\n}\n\n.listingCardCarTypeAndTransmissionLabelFlexContainer {\n\tdisplay: flex;\n\tfont-size: 14px;\n\tcolor: var(--primary-foreground);\n\talign-items: center;\n}\n\n.listingCardCarTypeAndTransmissionLabelFlexContainer>div {\n\tmax-width: 50%;\n}\n\n.transmissionLabelText {\n\tposition: relative;\n\tpadding-inline-start: 15px;\n}\n\n.transmissionLabelText::before {\n\tcontent: '';\n\tposition: absolute;\n\twidth: 4px;\n\theight: 4px;\n\tbackground: var(--common-background-color);\n\tborder-radius: 50%;\n\tleft: 5px;\n\ttop: 8px;\n}\n.carTypeIcon{\n\tposition: relative;\n\ttop: -2px;\n}\n\n@media(max-width:767px) {\n\t.positionRelative {\n\t\tpadding: 5px 0;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navigationIcon": `HomeSlider-navigationIcon-YLye3`,
	"HRCar": `HomeSlider-HRCar-TQDpn`,
	"PerDay": `HomeSlider-PerDay-IuURU`,
	"perNightCss": `HomeSlider-perNightCss-BwPPe`,
	"HRDetails": `HomeSlider-HRDetails-MLh7_`,
	"HRRight": `HomeSlider-HRRight-WsgYh`,
	"btn": `HomeSlider-btn-D4496`,
	"margintop5": `HomeSlider-margintop5-XpEjt`,
	"sliderbackground": `HomeSlider-sliderbackground-GmCm0`,
	"hiddentextSlider": `HomeSlider-hiddentextSlider-oV6Cv`,
	"positionRelative": `HomeSlider-positionRelative-Qvr79`,
	"boxShadow": `HomeSlider-boxShadow-v7K0V`,
	"titleCss": `HomeSlider-titleCss-iNvNi`,
	"reviewCss": `HomeSlider-reviewCss-B1tOg`,
	"arrowIconCss": `HomeSlider-arrowIconCss-ssom4`,
	"trip": `HomeSlider-trip-Mlv27`,
	"carType": `HomeSlider-carType-zAR9b`,
	"dotCss": `HomeSlider-dotCss-tUM7c`,
	"reviewCssImg": `HomeSlider-reviewCssImg-_Vw54`,
	"textFlow": `HomeSlider-textFlow-BJQAL`,
	"instantIcon": `HomeSlider-instantIcon-X5_4z`,
	"homeSlickSliderContainer": `HomeSlider-homeSlickSliderContainer-I57ss`,
	"carTypeText": `HomeSlider-carTypeText-D0TYn`,
	"listingCardCarTypeAndTransmissionLabelFlexContainer": `HomeSlider-listingCardCarTypeAndTransmissionLabelFlexContainer-g5rFA`,
	"transmissionLabelText": `HomeSlider-transmissionLabelText-MOvSk`,
	"carTypeIcon": `HomeSlider-carTypeIcon-flOTm`
};
module.exports = ___CSS_LOADER_EXPORT___;
